'use strict';

var debug;
if (process.env.NODE_ENV !== 'production') {
    debug = require('debug')('hbnb:module:ui:singleDate');
}

var _invoke = require('../invoke');

/**
 * 日期选择
 *
 * TODO: 补全示例
 *
 * 支持版本
 * + iHotel/5.9.2+
 *
 * @memberof ui
 * @static
 * @name selectDate
 * @param {String} current 当前日期
 * @param {String} maxDate 最大可选日期
 * @param {String} minDate 最小可选日期
 * @return {Promise<date | err>}
 * @example
 *  hbnb.ui.selectDate('');
 */
module.exports = function(current, maxDate, minDate) {
    if (process.env.NODE_ENV !== 'production') {
        debug('current is %s', current);
        debug('maxDate is %s', maxDate);
        debug('minDate is %s', minDate);
    }

    var p = new Promise(function(resolve, reject) {
        _invoke('ui', 'select_date', {
            original: current || '',
            maxDate: maxDate,
            minDate: minDate,
            callback: function(data) {
                resolve(data);
            },
            errback: function(err) {
                reject(err);
            }
        });
    });

    return p;
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/@hfe/hbnb/ui/select-date.js
// module id = uSpP
// module chunks = 0